<template>
    <div class="card">
        <div class="card-body">
            <b-row>
                <b-col md="12">
                    <h4 class="card-title">{{$t('order.opmerkingen')}} ({{notes ? notes.length : 0}})</h4>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <div class="sl-item" v-for="item in notes" v-bind:key="item.id">
                        <a href="#" class="link">{{item.user.fullName}}</a><span class="sl-date">&nbsp;{{item.createdAt | datetime}}</span>
                        <span class="pull-right">
                            <delete title="Notitie" 
                                :noRedirect="true" 
                                :hideText="true" 
                                :id="item.id" 
                                :entityId="item.entityId"
                                namespace="shared" 
                                resource="notes" />
                        </span>
                        <p class="m-t-10"> {{item.description}}</p>
                    </div>
                </b-col>
            </b-row>
            <b-row class="no-printable">
                <b-col md="12">
                    <hr/>
                    <b-form @submit="onSubmit" autocomplete="off">
                        <b-form-group :label="$t('order.opmerking')" label-for="content" >
                            <b-form-textarea v-model="command.description"  :placeholder="$t('klantrelaties.uwopmerking')" :rows="3" :max-rows="6" />
                        </b-form-group>
                        <b-button size="sm" type="submit" variant="themecolor" class="pull-right">{{$t('buttons.opmerkingplaatsen')}}</b-button>
                    </b-form>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'

//Import command
import Command from './command'

export default {
    name: 'notes',
    data () {
      return {
        command: new Command()
      }
    },
    props: ['entityId'],
    computed: {
      ...mapGetters ('shared',['notes'])
    },
    methods: {
      ...mapActions('shared',['getEntities','addNote']),
      onSubmit (event) {
        event.preventDefault();
        var vm = this;
        vm.command.entityId = vm.entityId;
        vm.addNote(vm.command)
        .then(() => {
            vm.command = new Command()
        })
      }
    },
    created() {
      var vm = this;
      vm.getEntities({
            resource: 'notes',
            entityId: vm.entityId
        });
    }
}
</script>